import { render, staticRenderFns } from "./BfBalanceLog.vue?vue&type=template&id=35754d0c&scoped=true"
import script from "./BfBalanceLog.vue?vue&type=script&lang=js"
export * from "./BfBalanceLog.vue?vue&type=script&lang=js"
import style0 from "./BfBalanceLog.vue?vue&type=style&index=0&id=35754d0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35754d0c",
  null
  
)

export default component.exports